export default {
  setUsers(state, payload) {
    state.users = payload;
  },
  addUser(state, payload) {
    state.users.unshift(payload);
  },
  updateUser(state, payload) {
    const index = state.users.findIndex(
      (item) => item.username === payload.username
    );
    if (index !== -1) {
      // Merge updates onto existing user — preserve fields not in payload
      state.users[index] = { ...state.users[index], ...payload };
    }
  },
  deleteUser(state, username) {
    const index = state.users.findIndex((item) => item.username === username);
    if (index !== -1) {
      state.users[index].is_deleted = 1;
    }
  },
  changeUserStatus(state, payload) {
    const index = state.users.findIndex(
      (item) => item.username === payload.username
    );
    if (index !== -1) {
      // Normalize boolean (from base-toggle) and number callers to 0/1 so the
      // status filter `user.status === 1` keeps working without a reload.
      state.users[index].status = payload.status ? 1 : 0;
    }
  },
  updateUserStatus(state, payload) {
    const index = state.users.findIndex(
      (item) => item.username === payload.username
    );
    if (index !== -1) {
      state.users[index].status = payload.status ? 1 : 0;
    }
  },
};
